import { ref as f, onMounted as E, onBeforeUnmount as L, defineComponent as B, computed as _, watch as x, openBlock as v, createBlock as O, resolveDynamicComponent as $, normalizeClass as F, withCtx as I, unref as z, createElementBlock as M, Fragment as R, renderSlot as g, createCommentVNode as S } from "vue";
function q(a, u = {}, r) {
  const t = f(!1), l = f(!1), i = f(!1), c = f(null);
  let n = null, o = null;
  const e = (s) => typeof s == "string" ? document.querySelector(s) : s instanceof Element ? s : null, y = () => {
    o && clearTimeout(o), n && (n.disconnect(), n = null);
  }, h = () => {
    const {
      root: s,
      rootMargin: k = "0px 0px 0px 0px",
      thresholds: w = [0],
      delay: T = 500
    } = u, b = {
      root: e(s),
      rootMargin: k,
      threshold: w
    };
    n = new IntersectionObserver(async (C) => {
      const m = C[0];
      if (m.intersectionRatio === 0 && !m.isIntersecting || t.value) {
        o && clearTimeout(o);
        return;
      }
      o = setTimeout(async () => {
        if (!r) {
          t.value = !0;
          return;
        }
        l.value = !0;
        try {
          c.value = await r(), i.value = !0, t.value = !0;
        } catch (p) {
          throw console.error("Lazy load error:", p), p;
        } finally {
          l.value = !1;
        }
      }, T);
    }, b), a.value && n.observe(a.value);
  };
  return E(() => {
    h();
  }), L(() => {
    y();
  }), {
    visible: t,
    running: l,
    done: i,
    data: c
  };
}
const D = /* @__PURE__ */ B({
  __name: "Lazy",
  props: {
    tag: { default: "div" },
    options: { default: () => ({}) },
    lazyTask: { type: Function, default: void 0 }
  },
  emits: ["visible", "done", "error"],
  setup(a, { emit: u }) {
    const r = a, t = f(null), {
      visible: l,
      running: i,
      done: c,
      data: n
    } = q(t, r.options, async () => {
      if (!r.lazyTask)
        return !0;
      try {
        const e = await r.lazyTask();
        return u("done", e), e;
      } catch (e) {
        throw u("error", e), e;
      }
    }), o = _(() => ({
      "pt-lazy": !0,
      "pt-lazy--running": i.value,
      "pt-lazy--done": c.value,
      "common-lazy": !0,
      "common-lazy--running": i.value,
      "common-lazy--done": c.value
    }));
    return x(() => l.value, (e) => {
      e && u("visible");
    }), (e, y) => (v(), O($(e.tag), {
      ref_key: "lazyElement",
      ref: t,
      class: F(o.value)
    }, {
      default: I(() => [
        z(l) ? (v(), M(R, { key: 0 }, [
          e.$slots.default ? g(e.$slots, "default", {
            key: 0,
            data: z(n)
          }) : S("", !0)
        ], 64)) : g(e.$slots, "loading", { key: 1 })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), d = D;
d.install = (a) => {
  a.component(d.name, d);
};
export {
  d as PtLazy,
  d as default,
  q as useLazyLoad
};
